import { render, staticRenderFns } from "./SettingsTableSidebar.vue?vue&type=template&id=2f3e36e5"
import script from "./SettingsTableSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsTableSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports